import ProfileAction from '../actions/profile/ProfileAction'

type State = {
  profileImage: string,
  userName: string
}

class ProfileReducer {

  private static initialState: State = {
    profileImage: "",
    userName: ""
  }

  static reducer = (state = ProfileReducer.initialState, action) => {
    switch (action.type) {

      case ProfileAction.SET_PROFILE_IMAGE:
        return {
          ...state,
          profileImage: action.payload.image
        }

      case ProfileAction.SET_USERNAME:
        return {
          ...state,
          userName: action.payload.username
        }

    }
    return state
  }
} 

export default ProfileReducer